import { render } from "./SupportBanNote.vue?vue&type=template&id=c139996c"
import script from "./SupportBanNote.vue?vue&type=script&lang=js"
export * from "./SupportBanNote.vue?vue&type=script&lang=js"

import exportComponent from "E:\\doc\\projects\\copAccraCrusade\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__